<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'LEGAL.HERO_EYEBROW' | translate }}
      </div>
      <h1 class="ph-hero__title">{{ 'COOKIES.TITLE' | translate }}</h1>
      <nav class="ph-legal-nav" aria-label="Legal">
        <a routerLink="/legal/privacy" routerLinkActive="ph-legal-nav__link--active">{{ 'PRIVACY.TITLE' | translate }}</a>
        <a routerLink="/legal/privacy-policy" routerLinkActive="ph-legal-nav__link--active">{{ 'PRIVACY_POLICY.TITLE' | translate }}</a>
        <a routerLink="/legal/cookie-preferences" routerLinkActive="ph-legal-nav__link--active">{{ 'COOKIES.TITLE' | translate }}</a>
        <a routerLink="/legal/terms" routerLinkActive="ph-legal-nav__link--active">{{ 'TERMS.TITLE' | translate }}</a>
      </nav>
    </div>
  </section>

  <section class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <article class="ph-legal">
        <p class="ph-legal__updated">
          {{ 'COOKIES.LAST_UPDATED' | translate }}: {{ '2024-03-20' | date:'longDate' }}
        </p>

        <section>
          <h2>{{ 'COOKIES.OVERVIEW.TITLE' | translate }}</h2>
          <p>{{ 'COOKIES.OVERVIEW.CONTENT' | translate }}</p>
        </section>

        <section class="ph-cookie-settings">
          <h2>{{ 'COOKIES.PREFERENCES.TITLE' | translate }}</h2>
          <p>{{ 'COOKIES.PREFERENCES.DESCRIPTION' | translate }}</p>

          <div class="ph-cookie-option">
            <div class="ph-cookie-option__head">
              <h3>{{ 'COOKIES.NECESSARY.TITLE' | translate }}</h3>
              <label class="ph-toggle">
                <input type="checkbox" checked disabled />
                <span class="ph-toggle__slider"></span>
              </label>
            </div>
            <p>{{ 'COOKIES.NECESSARY.DESCRIPTION' | translate }}</p>
          </div>

          <div class="ph-cookie-option">
            <div class="ph-cookie-option__head">
              <h3>{{ 'COOKIES.ANALYTICS.TITLE' | translate }}</h3>
              <label class="ph-toggle">
                <input type="checkbox" id="analytics" [(ngModel)]="cookiePreferences.analytics" />
                <span class="ph-toggle__slider"></span>
              </label>
            </div>
            <p>{{ 'COOKIES.ANALYTICS.DESCRIPTION' | translate }}</p>
          </div>

          <div class="ph-cookie-option">
            <div class="ph-cookie-option__head">
              <h3>{{ 'COOKIES.MARKETING.TITLE' | translate }}</h3>
              <label class="ph-toggle">
                <input type="checkbox" id="marketing" [(ngModel)]="cookiePreferences.marketing" />
                <span class="ph-toggle__slider"></span>
              </label>
            </div>
            <p>{{ 'COOKIES.MARKETING.DESCRIPTION' | translate }}</p>
          </div>

          <div class="ph-cookie-option">
            <div class="ph-cookie-option__head">
              <h3>{{ 'COOKIES.PREFERENCES.TITLE' | translate }}</h3>
              <label class="ph-toggle">
                <input type="checkbox" id="preferences" [(ngModel)]="cookiePreferences.preferences" />
                <span class="ph-toggle__slider"></span>
              </label>
            </div>
            <p>{{ 'COOKIES.PREFERENCES.DESCRIPTION' | translate }}</p>
          </div>

          <div class="ph-cookie-actions">
            <button type="button" class="ph-btn ph-btn--outline" (click)="rejectAll()">{{ 'COOKIES.REJECT_ALL' | translate }}</button>
            <button type="button" class="ph-btn ph-btn--brand" (click)="acceptAll()">{{ 'COOKIES.ACCEPT_ALL' | translate }}</button>
            <button type="button" class="ph-btn ph-btn--outline" (click)="openCustomizeModal()">{{ 'COOKIES.CUSTOMIZE' | translate }}</button>
          </div>
        </section>

        <section class="ph-legal__contact">
          <h2>{{ 'TERMS.CONTACT.TITLE' | translate }}</h2>
          <p>{{ 'TERMS.CONTACT.DESCRIPTION' | translate }}</p>
          <p><strong>{{ 'CONTACT.DATA.EMAIL_CONTACT.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.EMAIL_CONTACT.VALUE' | translate: translationParams }}</p>
          <p><strong>{{ 'CONTACT.DATA.PHONE.LABEL' | translate }}:</strong> {{ 'CONTACT.DATA.PHONE.VALUE' | translate: translationParams }}</p>
        </section>
      </article>
    </div>
  </section>
</div>

<div class="ph-modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="ph-modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="ph-modal__header">
      <h2>{{ 'COOKIES.MODAL.TITLE' | translate }}</h2>
      <button type="button" class="ph-modal__close" (click)="closeModal()" aria-label="Close">×</button>
    </div>
    <div class="ph-modal__body">
      <p>{{ 'COOKIES.MODAL.DESCRIPTION' | translate }}</p>

      <div class="ph-cookie-option">
        <div class="ph-cookie-option__head">
          <h3>{{ 'COOKIES.NECESSARY.TITLE' | translate }}</h3>
          <label class="ph-toggle">
            <input type="checkbox" checked disabled />
            <span class="ph-toggle__slider"></span>
          </label>
        </div>
        <p>{{ 'COOKIES.NECESSARY.DESCRIPTION' | translate }}</p>
      </div>

      <div class="ph-cookie-option">
        <div class="ph-cookie-option__head">
          <h3>{{ 'COOKIES.ANALYTICS.TITLE' | translate }}</h3>
          <label class="ph-toggle">
            <input type="checkbox" id="analytics-modal" [(ngModel)]="tempPreferences.analytics" />
            <span class="ph-toggle__slider"></span>
          </label>
        </div>
        <p>{{ 'COOKIES.ANALYTICS.DESCRIPTION' | translate }}</p>
      </div>

      <div class="ph-cookie-option">
        <div class="ph-cookie-option__head">
          <h3>{{ 'COOKIES.MARKETING.TITLE' | translate }}</h3>
          <label class="ph-toggle">
            <input type="checkbox" id="marketing-modal" [(ngModel)]="tempPreferences.marketing" />
            <span class="ph-toggle__slider"></span>
          </label>
        </div>
        <p>{{ 'COOKIES.MARKETING.DESCRIPTION' | translate }}</p>
      </div>

      <div class="ph-cookie-option">
        <div class="ph-cookie-option__head">
          <h3>{{ 'COOKIES.PREFERENCES.TITLE' | translate }}</h3>
          <label class="ph-toggle">
            <input type="checkbox" id="preferences-modal" [(ngModel)]="tempPreferences.preferences" />
            <span class="ph-toggle__slider"></span>
          </label>
        </div>
        <p>{{ 'COOKIES.PREFERENCES.DESCRIPTION' | translate }}</p>
      </div>
    </div>
    <div class="ph-modal__footer">
      <button type="button" class="ph-btn ph-btn--outline" (click)="closeModal()">{{ 'COOKIES.MODAL.CANCEL' | translate }}</button>
      <button type="button" class="ph-btn ph-btn--brand" (click)="saveAndCloseModal()">{{ 'COOKIES.MODAL.SAVE' | translate }}</button>
    </div>
  </div>
</div>
